import { render, staticRenderFns } from "./index-park.vue?vue&type=template&id=05c8e31b&scoped=true&"
import script from "./index-park.vue?vue&type=script&lang=js&"
export * from "./index-park.vue?vue&type=script&lang=js&"
import style0 from "./index-park.vue?vue&type=style&index=0&id=05c8e31b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8e31b",
  null
  
)

export default component.exports